import styled from 'styled-components';

const Wrapper = styled.main`
    background-color: ${({ theme }) => theme.gray_6};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;

    & > div {
        background-color: ${({ theme }) => theme.gray_7};
        max-width: 35rem;
        padding: 1em 2em;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.07);
        border-radius: ${({ theme }) => theme.borderRadius_lg};
    }

    h2 {
        text-transform: capitalize;
    }

    p {
        font-family: ${({ theme }) => theme.style_primary};
        line-height: 1.4em;
    }

    a {
        color: ${({ theme }) => theme.purple_1};
        text-decoration: underline;
    }

    a:hover {
        color: ${({ theme }) => theme.purple_2};
    }
`;

function ErrorView({ children, ...props }) {
    return (
        <Wrapper {...props}>
            <div>{children}</div>
        </Wrapper>
    );
}

export default ErrorView;
